import React from 'react';

import Fallback from 'v3/components/Fallback';
import Text from 'v3/components/Text';

import Attachment from '../Attachment';
import * as Styled from '../styles';

export function DocumentType({
  title,
  documents,
  onClickPreview,
  fetchDocuments,
  emittedId,
  setLoading,
}) {
  return (
    <div className="text-center mt-4">
      <Text as="div" type="regular" color="dark" weight={500}>
        {title}
      </Text>
      <div>
        <Styled.ImageRow>
          <Fallback
            fall={documents.length === 0}
            component={
              <div className="text-center flex-fill">
                <Text color="gray">Nenhuma imagem enviada.</Text>
              </div>
            }
          >
            {documents.map((document) => (
              <Attachment
                key={document.id}
                document={document}
                onClickPreview={onClickPreview}
                fetchDocuments={fetchDocuments}
                emittedId={emittedId}
                setLoading={setLoading}
              />
            ))}
          </Fallback>
        </Styled.ImageRow>
      </div>
    </div>
  );
}
